if (!customElements.get('responsive-media-banner')) {
  customElements.define(
    'responsive-media-banner',
    class ResponsiveMediaBanner extends HTMLElement {
      connectedCallback() {
        this.autoplay = this.dataset.videoAutoplay === 'true';
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewportChange = this.updateVideoPlayback.bind(this);
        this.handleVisibilityChange = this.updateVideoPlayback.bind(this);

        this.mobileQuery.addEventListener('change', this.handleViewportChange);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.updateVideoPlayback();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      updateVideoPlayback() {
        const activeMedia = this.getActiveMedia();

        this.querySelectorAll('[data-banner-media] video').forEach((video) => {
          if (video.closest('[data-banner-media]') !== activeMedia || document.hidden) {
            video.pause();
            return;
          }

          if (this.autoplay) {
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch(() => {});
          }
        });
      }

      getActiveMedia() {
        if (this.mobileQuery.matches && this.classList.contains('responsive-media-banner--has-mobile-media')) {
          return this.querySelector('[data-banner-media="mobile"]');
        }

        return this.querySelector('[data-banner-media="desktop"]');
      }
    }
  );
}
